export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">
              BALIZA<span className="text-orange-600">V16</span>
            </h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Tu tienda especializada en balizas V16 conectadas y certificadas por la DGT.
            </p>
          </div>
          <div>
            <h4 className="font-bold mb-4">Productos</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/#productos" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Balizas V16
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Información</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="/#normativa" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Normativa DGT
                </a>
              </li>
              <li>
                <a href="/#beneficios" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Beneficios
                </a>
              </li>
              <li>
                <a href="/#contacto" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Contacto
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Política de Privacidad
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Términos y Condiciones
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  Política de Cookies
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">© 2026 BalizaV16. Todos los derechos reservados.</p>
          <div className="flex gap-4">
            <a
              href="#"
              className="w-10 h-10 bg-gray-800 hover:bg-orange-600 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a
              href="#"
              className="w-10 h-10 bg-gray-800 hover:bg-orange-600 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a
              href="#"
              className="w-10 h-10 bg-gray-800 hover:bg-orange-600 rounded-full flex items-center justify-center transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
            </a>
          </div>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
